import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { ModalWrapper } from '@/modules/perseo-billing/components';
import { ECencopayModalOriginCancelType } from '@/modules/perseo-billing/containers/payment-methods/components/cencopay';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import useEscapeKeyHandler from '@/modules/perseo-billing/hooks/use-escape-key-handler';
import { calculateDifferenceTime } from '@/modules/perseo-billing/hooks/use-timer-count-down';
import {
  setCancelOrderChangePaymentMethod,
  setIsModalCencopayGetTheAppVisible,
  setIsModalQRCencopayVisible,
  setQRData
} from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  CardHeader,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import { BtnPrimary, BtnPrimaryOutlined } from '../btns-atoms';

export const ChangePaymentMethod = () => {
  const buttonCloseRef = useRef(null);

  const { cencoPayModalGoBack, cencoPayTryOtherPayment } =
    useGtmBillingProduct();

  const dispatch = useAppDispatch();

  const { cancelOrderChangePaymentMethod, cencoPayQR } =
    useAppSelector((state) => state?.billing) || {};
  const isAppModalReturn =
    cancelOrderChangePaymentMethod ===
    ECencopayModalOriginCancelType.CHANGE_OF_APP_MODAL;
  useEscapeKeyHandler(!!cancelOrderChangePaymentMethod, buttonCloseRef);

  const [isTimeout] = useState(
    calculateDifferenceTime(cencoPayQR?.transactionCountdown ?? 0) <= 0
  );

  const handlerOpenModal = () => {
    cencoPayModalGoBack();
    dispatch(setCancelOrderChangePaymentMethod(null));

    if (isAppModalReturn) {
      dispatch(setIsModalCencopayGetTheAppVisible(true));
    }
    dispatch(setIsModalQRCencopayVisible(true));
  };

  const handlerCloseModal = () => {
    cencoPayTryOtherPayment();
    dispatch(setIsModalQRCencopayVisible(false));
    dispatch(setCancelOrderChangePaymentMethod(null));

    dispatch(setQRData(null));
    toast({
      title: 'Anulaste el pago con CencoPay',
      body: 'Continúa con otro medio de pago.',
      position: 'top-right'
    });
  };

  const modalContent = (
    <ModalWrapper
      size="sm"
      fullWidth
      open={!!cancelOrderChangePaymentMethod}
      onClose={handlerOpenModal}
      roundedType="FIXED_BOTTOM"
    >
      <Card p={16}>
        <CardHeader
          pb={16}
          action={
            <div
              ref={buttonCloseRef}
              className="co-cursor-pointer"
              onClick={handlerOpenModal}
            >
              <Icon icon="CloseIcon" width={16} height={16} />
            </div>
          }
          title={
            <div className="co-flex co-gap-[12px] co-items-center">
              {isTimeout ? (
                <Icon
                  icon="InformationIcon"
                  height={21}
                  width={21}
                  className="co-text-pds-neutral-900 !co-fill-[#DA7400] co-flex-shrink-0"
                />
              ) : (
                <Icon icon="CellPhoneWithBtn" width={18} height={18} />
              )}

              <Typography
                className="co-font-[18px]"
                size="h3"
                weight="semibold"
              >
                {isTimeout
                  ? '¿Quieres cambiar de medio de pago?'
                  : 'Pagar con CencoPay'}
              </Typography>
            </div>
          }
        />

        <Divider />
        <div className="co-flex co-flex-col co-gap-4 co-px-[8px] co-pt-4 co-pb-[8px]">
          <Typography className="co-overflow-ellipsis co-overflow-hidden !co-text-[16px]">
            {isTimeout
              ? 'Se anulará el pago con CencoPay.'
              : 'Lo sentimos, el código QR expiró. Por favor, intenta de nuevo o elige otro medio de pago.'}
          </Typography>
          <BtnPrimary
            label={isTimeout ? 'Cambiar' : 'Volver'}
            actionClick={handlerCloseModal}
          />
          {isTimeout && (
            <BtnPrimaryOutlined
              label={'Volver'}
              actionClick={handlerOpenModal}
            />
          )}
        </div>
      </Card>
    </ModalWrapper>
  );

  const modalElement = document.getElementById(
    'modal-cencopay-qr-change-method'
  );
  return modalElement ? createPortal(modalContent, modalElement) : null;
};
